import { __awaiter, __generator } from "tslib";
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { logError } from '@office-start/telemetry-service';
import { applyOfficeIdentity, httpGet } from '@office-start/xhr-service';
// Constants
var cultureArg = 'culture=';
var appArg = 'app=';
var limitArg = 'show=';
var flightsArg = 'flights=';
var templateIdArg = 'id=';
var isIwArg = 'isIw=';
var isAdminArg = 'isAdmin=';
var isSmbArg = 'isSmb=';
var isEduArg = 'isEdu=';
var isEduFacultyArg = 'isEduFaculty=';
var isEduStudentArg = 'isEduStudent=';
var authIdArg = 'authId=';
var pageArg = 'page=';
var firstVisitAgeInWeeksArg = 'firstVisitAgeInWeeks=';
var browserNameArg = 'browserName=';
var osNameArg = 'osName=';
var osVersionArg = 'osVersion=';
var deploymentEnvironmentArg = 'deploymentEnvironment=';
var templateBinaryUrlArg = 'templateBinaryUrl=';
var templatesContentPath = '/content';
function getTemplateContentDataUrl(options) {
    var templatesMetadataApiQueryParams = "&".concat(browserNameArg).concat(options.browserName, "&").concat(flightsArg).concat(options.flights, "&").concat(isIwArg).concat(options.isIw, "&").concat(isAdminArg).concat(options.isAdmin, "&").concat(isSmbArg).concat(options.isSmb, "&").concat(isEduFacultyArg).concat(options.isEduFaculty, "&").concat(isEduStudentArg).concat(options.isEduStudent, "&").concat(authIdArg).concat(options.authId, "&").concat(firstVisitAgeInWeeksArg).concat(options.firstVisitAgeInWeeks, "&").concat(pageArg).concat(options.page, "&").concat(deploymentEnvironmentArg).concat(options.deploymentEnvironment, "&").concat(osNameArg).concat(options.osName, "&").concat(osVersionArg).concat(options.osVersion);
    return "".concat(options.officeHomeApiRoot, "/").concat(options.templatesApiEndpoint + templatesContentPath, "?").concat(appArg).concat(options.app, "&").concat(cultureArg).concat(options.officeMarket, "&").concat(limitArg).concat(options.show, "&").concat(templateIdArg).concat(options.templateId, "&").concat(templateBinaryUrlArg).concat(options.templateBinaryUrl, "&").concat(isEduArg).concat(options.isEdu).concat(templatesMetadataApiQueryParams);
}
export function fetchTemplateContentData(options) {
    return __awaiter(this, void 0, void 0, function () {
        var url, requestConfig;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = getTemplateContentDataUrl(options);
                    return [4 /*yield*/, applyOfficeIdentity({}, options.inMockMode, options.workload, options.getIdentity)];
                case 1:
                    requestConfig = _a.sent();
                    return [2 /*return*/, httpGet(KnownInstrumentationEvents.TemplateContentRequest, "Template_Content" /* KnownRequestInstrumentationEvents.TemplateContentRequest */, url, requestConfig, options.jwtAuthEnabled, options.getAccessToken, options.officeHomeApiRoot, options.correlationId, 'OfficeHome', {
                            populateRequestEvent: function (response, params) {
                                if (response.ok) {
                                    params["ElementId" /* InstrumentationParam.ElementId */] = options.templateId;
                                    params["ItemCategory" /* InstrumentationParam.ItemCategory */] = options.app;
                                }
                                else {
                                    params["HttpCode" /* InstrumentationParam.HttpCode */] =
                                        700 /* HttpStatusCode.UnexpectedResponse */.toString();
                                }
                            },
                        })
                            .then(function (response) {
                            if (!response || !response.data || !response.ok) {
                                throw new Error((response === null || response === void 0 ? void 0 : response.statusText) || 'Null response');
                            }
                            if (!response.data.Application ||
                                !response.data.Content ||
                                !response.data.Content.Value) {
                                throw new Error('Invalid response');
                            }
                            return {
                                Value: response.data.Content.Value,
                                Application: response.data.Application,
                            };
                        })
                            .catch(function (error) {
                            logError({
                                eventName: 'Form_Content_Fetch_Error',
                                message: error,
                            });
                            return undefined;
                        })];
            }
        });
    });
}
//# sourceMappingURL=fetchTemplateContentData.js.map